<template>
  <div class="administrator">
    <v-dialog v-model="accountActivationModal" width="500">
      <v-card>
        <v-card-title>
          <p>Account Activation</p>
        </v-card-title>
        <v-card-text>
          <v-form ref="activationForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Enter Email Address"
                  aria-required="true"
                  v-model="formData.email"
                  type="email"
                  prepend-inner-icon="email"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="accountActivationModal = false">
            Close
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="!submitting"
            color="primary"
            @click="sendActivationLink()"
            >Send Activation Link</v-btn
          >
        </v-card-actions>
        <v-card-actions>
          <v-btn block v-if="submitting" color="error"
            >Sending Activation Link, Please wait...</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ActivationModal",
  props: {
    accountDialogBox: Boolean,
  },
  data: () => ({
    dialog: false,
    submitting: false,
    formData: {
      email: "",
    },
  }),
  computed: {
    accountActivationModal: {
      get() {
        return this.accountDialogBox;
      },
      set(value) {
        this.setAccountActivationModal(value);
      },
    },
    rules() {
      return {
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
      };
    },
  },
  methods: {
    setAccountActivationModal(value) {
      this.$emit("setAccountActivationModal", value);
    },
    sendActivationLink() {
      this.submitting = true;
      if (
        this.formData.email.length === 0 ||
        !/.+@.+/.test(this.formData.email)
      ) {
        this.$refs.activationForm.validate();
        this.submitting = false;
      } else {
        this.$store.dispatch("Administrator/adminSendActivationLink", {
          email: this.formData.email,
        });
        setTimeout(() => {
          this.submitting = false;
        }, 10000);
      }
    },
  },
};
</script>

<style scoped>
@import url("../../styles/administrator.css");
</style>
